import { PropsWithChildren, ReactNode } from 'react';

import {
  DialogActions,
  DialogContent,
  Stack,
  tokens,
} from '@cast/design-system';

type Props = PropsWithChildren<{
  variant?: 'success' | 'error';
  title?: string;
  actions?: ReactNode;
}>;

/**
 * @deprecated Old dialog system — this layout uses old building blocks (`DialogTitle`,
 * `DialogContent`, `DialogActions`, `CloseDialogButton`). Rebuild on `DialogV2` from
 * `@cast/design-system` (or composed building blocks) before reuse.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const DialogFeedbackLayout = ({ variant, children, actions }: Props) => {
  return (
    <Stack
      position="relative"
      data-testid={
        variant === 'success' ? 'feedback-success' : 'feedback-failure'
      }
    >
      <DialogContent>{children}</DialogContent>
      <DialogActions
        sx={{
          py: 16,
          px: 24,
          borderTop: tokens.theme.border.structural.neutral,
        }}
      >
        {actions}
      </DialogActions>
    </Stack>
  );
};
